"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.department")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.department.tax", {
            url: "/fiscal?accountPlanType&typeImport",
            params: {
                typeImport: { value: null, dynamic: true },
                accountPlanType: { value: null, dynamic: true }
            }
        })
        .state("nucont.accounting.company.department.tax.import", {
            url: "/importar",
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentTaxImportComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.department.tax.edit", {
            url: "/editar",
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentTaxEditComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },

            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.department.tax.scenarios", {
            url: "/cenarios/:scenarioId?accountsPlanType",
            params: {
                scenarioId: { value: null, dynamic: true },
                accountsPlanType: { value: null, dynamic: true }
            },
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentTaxScenariosComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "department-module"
        });
}
